<template>
    <div class="container h-full">
        <div class="overflow-hidden rounded-md">
            <div class="px-4 py-5 space-y-6 bg-white">
                <div>
                    <div class="block text-sm font-medium text-gray-700">
                        {{ $t('TXT_BANK_NAME') }}
                    </div>
                    <div class="flex flex-col mt-1 rounded-md shadow-sm">
                        <t-input
                            v-model="form.name"
                            placeholder="Bank Name"
                            :variant="errors('name') ? 'danger' : ''"
                        />
                        <div
                            v-if="errors('name')"
                            class="text-red-500"
                        >
                            {{ errors('name') }}
                        </div>
                    </div>
                </div>

                <div class="py-2 text-right">
                    <t-button
                        :disabled="processing"
                        variant="success"
                        @click="submitForm"
                    >
                        {{ editData ? 'Update' : 'Save' }}
                    </t-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BankForm',

    props: {
        editData: {
            type: Object,
        },
    },

    data() {
        return {
            form: { name: '' },
            processing: false,
        };
    },

    mounted() {
        if (this.editData) this.form = { id: this.editData.id, name: this.editData.name };
    },

    methods: {
        submitForm() {
            this.editData ? this.update(this.form) : this.save(this.form);
        },

        save(payload) {
            this.processing = true;
            this.$inertia.post(route('banks.store'), payload, {
                onSuccess: () => {
                    this.$emit('transactionComplete');
                },
                onFinish: () => {
                    this.processing = false;
                },
            });
        },

        update(payload) {
            this.processing = true;
            this.$inertia.patch(route('banks.update', this.editData.id), payload, {
                onSuccess: () => {
                    this.$emit('transactionComplete');
                },
                onFinish: () => {
                    this.processing = false;
                },
            });
        },
    },
};
</script>

<style scoped></style>
